// extracted by mini-css-extract-plugin
module.exports = {"table_title":"Overview_table_title__17XmA","status_color":"Overview_status_color__2deun","body_text":"Overview_body_text__1pNCq","header_text":"Overview_header_text__2jBUE"};